import { render, staticRenderFns } from "./reservationPreferences.vue?vue&type=template&id=0fed625a&scoped=true"
import script from "./reservationPreferences.vue?vue&type=script&lang=js"
export * from "./reservationPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed625a",
  null
  
)

export default component.exports